import * as React from 'react'
import { get as _get } from 'lodash'
import { inject, observer } from 'mobx-react'
import styles from './index.scss'
import { ComponentExt } from 'util/reactExt'
import { checkType, taskStatus, checkStatus } from 'constants/index'
import TestListModal from 'containers/views/Levelup/TestListModal'
import FailModal from 'containers/views/Levelup/FailModal'
import VideoCheck from 'containers/views/Levelup/VideoCheck'
import PlayIcon from 'components/PlayIcon'
import loseVoice from 'assets/audio/lose.mp3'
// import bgVoice from 'assets/audio/bg.mp3'
const bgVoice = '//ss.yidejia.com/xy-front/dist/qa/static/fonts/bg.1af28d1.mp3'

interface ICheckPanelProps {
  check: any // 当前弹窗显示的关卡信息
  levelStore?: any
  onOpenPassCheckModal: () => void
  onOpenFailCheckModal: () => void
  onCloseCheckPanelModal: () => void
  testData?: any
  testRef?: any
  hiddenMusicIcon?: boolean
}

interface ICheckPanelState {
  btnClicked: boolean
  showFailResult: boolean // 是否展示习题关或必通关错误结果
  failureContent: any
  currentTaskIndex: number
  finishProgress: string
  isPlay: boolean
}

@inject('globalStore', 'levelStore')
@observer
export default class CheckPanel extends ComponentExt<
  ICheckPanelProps,
  ICheckPanelState
> {
  state = {
    btnClicked: false,
    showFailResult: false,
    failureContent: null,
    currentTaskIndex: 0,
    finishProgress: '',
    isPlay: true,
  }

  private testRef

  constructor(props) {
    super(props)
  }

  renderVideoCheck = () => {
    const { onCloseCheckPanelModal, onOpenPassCheckModal } = this.props
    return (
      <div className={`${'styles.videoCheck'} ${styles.check}`}>
        <VideoCheck
          toggleAudioVoice={this.toggleAudioVoice}
          check={this.props.check}
          setCurrentTaskIndex={this.setCurrentTaskIndex}
          onCloseCheckPanelModal={onCloseCheckPanelModal}
          onOpenPassCheckModal={onOpenPassCheckModal}
        />
      </div>
    )
  }

  setCurrentTaskIndex = (val: number): void => {
    this.setState({
      currentTaskIndex: val,
    })
  }

  renderExampleOrExamCheck = (mode: string) => {
    const {
      check: {
        check: { type },
      },
    } = this.props
    return (
      <div className={`${styles.examCheck} ${styles.check}`}>
        <h2 className={styles.examTitle}>
          {type === checkType.exam ? '通关大挑战' : '练习题'}
        </h2>
        <div className={styles.split} />
        <div className={`${'styles.content'} ${styles.checkContent}`}>
          <TestListModal
            data={this.props.testData}
            onRef={this.onRef}
            onProgressChanged={this.onProgressChanged}
          />
        </div>
        <a
          className={`${styles.btn} ${
            !this.isCheckDone ? 'styles.coverBtn' : ''
          } ${this.isCheckDone ? styles.disabled : ''}`}
          onClick={this.submitExam}
          onMouseDown={this.switchBtnEffect.bind(this, '+')}
          onMouseUp={this.switchBtnEffect.bind(this, '-')}
        >
          {'我已完成'}
        </a>
      </div>
    )
  }

  get isCheckDone(): boolean {
    const {
      check: { status },
    } = this.props
    return status === checkStatus.done
  }

  onProgressChanged = val => {
    this.setState({
      finishProgress: val,
    })
  }

  submitExam = async (): Promise<any> => {
    const {
      check: {
        check: { type },
      },
      levelStore: { getUserCheckRecord, toggleAudioVoice },
      onOpenPassCheckModal,
    } = this.props
    if (this.isCheckDone) {
      return
    }

    if (type === checkType.example) {
      if (this.testRef.completeTest) {
        onOpenPassCheckModal()
      } else {
        this.$message.info('请答完所有试题。')
      }
      return
    }
    const { isPassed, content } = await this.testRef.handleSubmit()
    getUserCheckRecord({
      per_page: 100,
      page: 1,
    })

    if (isPassed) {
      // 展示通关成功
      onOpenPassCheckModal()
    } else {
      // 展示通关失败
      this.setState({
        showFailResult: true,
        failureContent: content,
      })
      toggleAudioVoice({ src: loseVoice, loop: '' })
    }
  }

  onRef = ref => {
    this.testRef = ref
  }

  renderTextCheck = () => {
    const { check } = this.props
    const { btnClicked } = this.state
    const checkTask = _get(check, 'check_task_records[0].check_task')
    return (
      <div className={`${styles.textCheck} ${styles.check}`}>
        {/*<h2>{checkTask.name}</h2>*/}
        <p
          className={`${styles.textContent} ${styles.checkContent}`}
          dangerouslySetInnerHTML={{
            __html: checkTask.text && checkTask.text.text,
          }}
        />
        <a
          className={`${'styles.textBtn'} ${styles.btn} ${
            btnClicked && !this.isCheckDone ? styles.click : ''
          } ${this.isCheckDone ? styles.disabled : ''}`}
          onClick={this.onCloseTextModal}
          onMouseDown={this.switchBtnEffect.bind(this, '+')}
          onMouseUp={this.switchBtnEffect.bind(this, '-')}
        >
          我已阅读
        </a>
      </div>
    )
  }

  renderFailResultComponent = () => {
    const { btnClicked } = this.state

    return (
      <div className={`${styles.examCheck} ${styles.check}`}>
        <h2 className={styles.examTitle}>本次闯关失败，请再接再厉！</h2>
        <div className={styles.split} />
        <div className={'styles.content'}>
          <FailModal failureContent={this.state.failureContent} />
        </div>
        <a
          className={`${'styles.examBtn'} ${styles.btn} ${
            btnClicked ? styles.click : ''
          }`}
          onClick={this.closeFailResultModal}
          onMouseDown={this.switchBtnEffect.bind(this, '+')}
          onMouseUp={this.switchBtnEffect.bind(this, '-')}
        >
          确定
        </a>
      </div>
    )
  }

  onCloseTextModal = async (): Promise<any> => {
    const {
      check: { check_task_records },
      onCloseCheckPanelModal,
      onOpenPassCheckModal,
    } = this.props

    if (this.isCheckDone) {
      return
    }

    const isFinished = await this.getStatusOfTask(check_task_records[0])

    if (isFinished) {
      setTimeout(() => {
        onCloseCheckPanelModal()
        onOpenPassCheckModal()
      }, 400)
    }
  }

  closeFailResultModal = () => {
    const {
      levelStore: { toggleAudioVoice },
    } = this.props
    this.setState({
      showFailResult: false,
    })
    toggleAudioVoice({ src: '' })

    this.props.onCloseCheckPanelModal()
  }

  getStatusOfTask = async (task: any): Promise<any> => {
    const {
      levelStore: { getCheckTaskRecord, getUserCheckRecord },
      check: { grade },
    } = this.props

    if (task.status === taskStatus.done) {
      this.$message.success('当前任务已完成。')
      return true
    }

    const isTaskStatusChanged = await getCheckTaskRecord(task.id, grade - 1)
    if (!isTaskStatusChanged) {
      this.$message.info('您尚未完成当前任务。')
      return false
    } else {
      this.$message.success('当前任务已完成。')
      setTimeout(() => {
        getUserCheckRecord()
      }, 300)
      return true
    }
  }

  switchBtnEffect = (mode: string) => {
    this.setState({
      btnClicked: mode === '+' ? true : false,
    })
  }

  toggleAudioVoice = () => {
    const {
      levelStore: {
        bgAudioConfig: { src },
        toggleAudioVoice,
      },
    } = this.props

    if (src === bgVoice) {
      toggleAudioVoice(
        {
          src: '',
        },
        'bg',
      )
    } else {
      toggleAudioVoice(
        {
          src: bgVoice,
        },
        'bg',
      )
    }
  }

  render() {
    const {
      check: { check },
      onCloseCheckPanelModal,
      levelStore: {
        bgAudioConfig: { src },
      },
      hiddenMusicIcon,
    } = this.props
    const checkComponent: any = {
      [checkType.integration]: this.renderVideoCheck,
      [checkType.exam]: this.renderExampleOrExamCheck,
      [checkType.example]: this.renderExampleOrExamCheck,
      [checkType.text]: this.renderTextCheck,
    }

    const name = check && check.name
    const type = check && check.type
    const description = check && check.description
    const checkTaskRecords = this.props.check.check_task_records
      ? this.props.check.check_task_records
      : []
    const { showFailResult, currentTaskIndex, finishProgress } = this.state
    const isPlay = src === bgVoice ? true : false

    const progress: string =
      type === checkType.integration || type === checkType.text
        ? checkTaskRecords &&
          `${
            checkTaskRecords.filter(record => record.status === taskStatus.done)
              .length
          }/${checkTaskRecords.length}`
        : finishProgress

    return (
      <div className={styles.checkPanel}>
        <div className={styles.title}>{name}</div>
        <div className={styles.desc}>
          {description}({progress})
        </div>
        {!showFailResult
          ? checkComponent[type] && checkComponent[type]()
          : this.renderFailResultComponent()}
        <div className={styles.closeBtn} onClick={onCloseCheckPanelModal} />
        {(checkTaskRecords[currentTaskIndex] &&
          checkTaskRecords[currentTaskIndex].status) === taskStatus.done && (
          <div className={styles.seal} />
        )}
        <section className={styles.music}>
          {!hiddenMusicIcon && (
            <PlayIcon
              isPlay={isPlay}
              toggleAudioVoice={this.toggleAudioVoice}
            />
          )}
        </section>
      </div>
    )
  }
}
